// @ts-strict-ignore
export class ProjectIdentity {
  id: number;
  version: number;

  constructor(options?: {
    id: number,
    version: number
  }) {
    this.id = options.id;
    this.version = options.version;
  }
}
